const DEFAULT_ENV_TOKEN = "OMNIPLAY_DEV";
const DEFAULT_BACKEND_PORT = "8080";

function hasWindowEnv() {
  try {
    return typeof window !== "undefined" && window.ENV !== undefined;
  } catch (error) {
    return false;
  }
}

export function getConfig(name, defaultValue = null) {
  if (hasWindowEnv()) {
    return window.ENV[name] || window.ENV[`REACT_APP_${name}`] || defaultValue;
  }

  if (typeof process !== "undefined") {
    return process.env[name] || defaultValue;
  }

  return defaultValue;
}

function guessBackendUrl() {
  if (typeof window === "undefined") {
    return null;
  }

  const { protocol, hostname, port } = window.location;
  if (!hostname) return null;

  // Ambiente local: front em 3000/3001 → backend geralmente em 8080
  if (port === "3000" || port === "3001" || port === "5173") {
    return `${protocol}//${hostname}:${DEFAULT_BACKEND_PORT}`;
  }

  // Produção: assume mesmo host/porta do frontend
  return `${protocol}//${hostname}${port ? `:${port}` : ""}`;
}

export function getBackendUrl() {
  return (
    getConfig("REACT_APP_BACKEND_URL") ||
    getConfig("BACKEND_URL") ||
    guessBackendUrl()
  );
}

export function getFrontendPort() {
  return getConfig("PORT") || getConfig("PORT");
}

export function getNumberSupport() {
  // Default: (18) 3621-5152 -> wa.me precisa de DDI+DDD+numero (somente dígitos)
  return (
    getConfig("REACT_APP_NUMBER_SUPPORT") ||
    getConfig("NUMBER_SUPPORT") ||
    "551836215152"
  );
}

export function getEnvToken() {
  return getConfig("REACT_APP_ENV_TOKEN") || getConfig("ENV_TOKEN") || DEFAULT_ENV_TOKEN;
}

export function getFacebookAppId() {
  return getConfig("REACT_APP_FACEBOOK_APP_ID") || getConfig("FACEBOOK_APP_ID");
}

export function getFacebookGraphVersion() {
  // Fonte única para versão do Graph (usada pelo Facebook JS SDK e widgets XFBML).
  // Permite override por env sem quebrar instalações antigas.
  return (
    getConfig("REACT_APP_FACEBOOK_GRAPH_VERSION") ||
    getConfig("FACEBOOK_GRAPH_VERSION") ||
    getConfig("REACT_APP_META_GRAPH_VERSION") ||
    getConfig("META_GRAPH_VERSION") ||
    "v24.0"
  );
}

export function getRequireBusinessManagement() {
  return (
    getConfig("REACT_APP_REQUIRE_BUSINESS_MANAGEMENT") ||
    getConfig("REQUIRE_BUSINESS_MANAGEMENT")
  );
}
